import { render, staticRenderFns } from "./PopupFrame.vue?vue&type=template&id=34ad65a6&scoped=true&"
import script from "./PopupFrame.vue?vue&type=script&lang=js&"
export * from "./PopupFrame.vue?vue&type=script&lang=js&"
import style0 from "./PopupFrame.vue?vue&type=style&index=0&id=34ad65a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ad65a6",
  null
  
)

export default component.exports